module.exports = __webpack_public_path__ + "img/open-sans-v18-latin-regular.7aab4c13.svg";